import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_ACCOUNT_GROUP_NAME } from './accountGroupBreadcrumb.query';

export { FETCH_ACCOUNT_GROUP_NAME } from './accountGroupBreadcrumb.query';

export function AccountGroupBreadcrumb() {
  const { translateBackendString } = useLocalization();
  const { t } = useTranslation();
  const { accountGroupId } = useParams();
  const { data } = useQuery(FETCH_ACCOUNT_GROUP_NAME, {
    variables: { id: accountGroupId },
  });

  return (
    translateBackendString(
      data?.fetchAccountGroup?.accountGroup?.translatedName,
    ) || t('client:accountGroup')
  );
}
